import React from 'react';
import { MobileSelectOptions } from "./MobileSelectOptions.js";
import { MobileSelectSelect } from "./MobileSelectSelect.js";
import { jsx as _jsx } from "react/jsx-runtime";
export function MobileSelect({
  parsedElements,
  activeItem,
  handleSelection
}) {
  if (!parsedElements.some(option => option.type === 'CATEGORY')) {
    return /*#__PURE__*/_jsx(MobileSelectSelect, {
      elements: parsedElements,
      activeItem: activeItem,
      onSelection: handleSelection,
      children: /*#__PURE__*/_jsx(MobileSelectOptions, {
        options: parsedElements.filter(element => !element.filtered)
      })
    });
  }

  // Group options by category
  const categories = [];
  for (const option of parsedElements) {
    if (option.type === 'CATEGORY' && !option.filtered) {
      categories.push({
        id: option.id,
        label: option.label,
        options: []
      });
    } else if (option.type === 'OPTION' && !option.filtered) {
      categories[categories.length - 1].options.push(option);
    }
  }
  return /*#__PURE__*/_jsx(MobileSelectSelect, {
    elements: parsedElements,
    activeItem: activeItem,
    onSelection: handleSelection,
    children: categories.map((category, index) => /*#__PURE__*/_jsx("optgroup", {
      label: category.label,
      disabled: false,
      children: /*#__PURE__*/_jsx(MobileSelectOptions, {
        options: category.options
      })
    }, category.id ?? index))
  });
}